module.exports = __webpack_public_path__ + "img/search-icon.44a7ab6e.svg";